// ===== Packages =====

import styled                       from 'styled-components';

export const Container = styled.div`
    width: 100vw;
    height: 100vh;
    height: 100svh;
    height: 100dvh;
    background: ${({ theme }) => theme.color.white};
`;
